import { API, Auth, Cache } from "aws-amplify";
//@ts-ignore
import { AmplifyEventBus } from 'aws-amplify-vue';


AmplifyEventBus.$on('authState', (info: string) => {
    if (info === 'signedOut' || info === 'signIn') {
        Cache.setItem('current-user', null)
    }
});

export class UserManagementDao {
    private readonly SIX_HOUR = 6 * 60 * 60 * 1000;
    private readonly API_NAME = "Viewpoint360API";
    private gettingCurrentUser = false;

    async getCurrentUser() {
        // on startup, the Auth.currentAuthenticatedUser can get spammed which results in
        // wasted calls and unnecessary cost. Wait on other thread to get and cache.
        // Waits a max of 1 second
        let counter = 0;
        while (this.gettingCurrentUser && counter < 10) {
            await new Promise(resolve => setTimeout(resolve, 100));
            counter++;
        }
        let user = Cache.getItem('current-user');
        if (user) {
            return user;
        }

        // Get current user profile
        this.gettingCurrentUser = true;
        let currentUserInfo = await Auth.currentAuthenticatedUser()
        let userId = currentUserInfo.getUsername();
        user = await this.getUserProfile(userId);
        Cache.setItem('current-user', user, {expires: Date.now() + this.SIX_HOUR});
        this.gettingCurrentUser = false;
        return user;
    }


    async getUserProfile(userId: string) {
        return API.get(this.API_NAME, `/users/${userId}/profile`, {});
    }

    async searchPublicUserProfilesByEmailPrefix(emailPrefix: string) {
        let myInit = { // OPTIONAL
            headers: {}, // OPTIONAL
            queryStringParameters: {  // OPTIONAL
                email: emailPrefix,
            },
        };
        return API.get(this.API_NAME, `/users/search`, myInit);
    }


}

export const USERS = new UserManagementDao();